<div class="content-wrapper" id="bannerClose">
    <div class="page-header">
        <h4 class="page-titles">
            <span class="page-title-icons bg-gradient-primary text-white mr-2">
                <i class="mdi mdi-file-document"></i>
            </span> การประเมินผลการดำเนินงาน
        </h4>
    </div>
    <div class="col-12 grid-margin">
        <div class="card">
            <div class="card-body">
                <h4 class="text-center"><u>กราฟแสดงผลการดำเนินงานของทุนหมุนเวียน</u></h4>
                <br>
                <div echarts [options]="EChartOption" class="demo-chart"></div>
            </div>
        </div>
    </div>
    <div class="col-12 grid-margin">
        <div class="card">
            <div class="card-body">
                <h4 class="text-center"><u>ตารางแสดงผลการดำเนินงานของกองทุนหมุนเวียน</u></h4><br>
                <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr class="bg-dark text-white">
                          <th scope="col">ด้านที่</th>
                          <th class="text-center" scope="col" *ngFor="let item of group_year; let i=index">ปี {{item.years}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of raw_json; let i=index">
                          <td> {{item.topic}}</td>
                          <td class="text-center" *ngFor="let list of item.value">{{list.score}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <hr>
                    <br>
                    

                  </div>
                  <br>
            </div>
        </div>
    </div>
    <div class="col-12 grid-margin">
        <div class="card">
            <div class="card-body">
                <h4 class="text-center"><u>รายงานผลการประเมินกองทุนหมุนเวียน</u></h4>
                <br>
                <table class="table table-hover">
                  <thead>
                    <tr >
                      <th scope="col" class="text-center">ปี</th>
                      <th scope="col" class="text-center" style="text-align: center;">เอกสารรายงาน</th>
                      <th scope="col" class="text-center" style="text-align: center;">เอกสารข้อตกลง</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of indi| paginate : {
                      itemsPerPage: tableSize,
                      currentPage: page,
                      totalItems: count
                    }; let i=index">
                      <td class="text-center">{{item.years}}</td>
                      <td class="text-center" style="text-align: center;">
                        <a href="https://ogc.mapedia.co.th/api/v1/lrfund/general/pdf/{{ item.report }}" type="button" class="btn btn-inverse-primary btn-sm" target="_blank" ><i class="mdi mdi-file-document" style="font-size: 12px;"></i></a>
                      </td>
                      <td class="text-center" style="text-align: center;">
                        <a href="https://ogc.mapedia.co.th/api/v1/lrfund/general/pdf/{{ item.agree }}" type="button" class="btn btn-inverse-primary btn-sm" target="_blank" ><i class="mdi mdi-file-document" style="font-size: 12px;"></i></a>
                      </td>
                    </tr>
           
                  </tbody>
                </table>
                
            </div>
            <pagination-controls previousLabel="ก่อนหน้า" nextLabel="ถัดไป" class="my-pagination"
                    (pageChange)="onTableDataChange($event)" style="text-align: center;">
                </pagination-controls>
        </div>
    </div>
</div>